module.exports = __webpack_public_path__ + "static/og-image-home-4b3d6e8e3eab04d4d057dee7a391d213.jpg";